export enum PlayerStatusEnum {
  BANNED = 0,
  ACTIVE = 1,
  READ_ONLY = 2,
  INACTIVE = 3,
}
